"use strict";
/**
 * Предоставляет инструменты для работы со сессионным хранилищем (sessionStorage).
 *
 * @namespace WebAccess.cache.sessionCache
 * @since 5.1.0.1534
 */
(function (global) {  
    var SessionCache = global.cache.Cache.extend({
      init: function (data) {
        this._super(data);
      },

      /** 
      * Проверить, поддерживается ли браузером сессионное хранилище (sessionStorage).
      *
      * @function WebAccess.cache.sessionCache.isStorageAvailable
      * @since 5.1.0.1505
      * @return {boolean} True – сессионное хранилище поддерживается браузером, иначе False.
      */
      isStorageAvailable: function () {
        return !!(window["sessionStorage"]);
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * @private 
      * @since 5.1.0.1505
      * @method WebAccess.cache.sessionCache._getStorage
      */
      _getStorage: function () {
        if (this.isStorageAvailable) return window.sessionStorage;
        else {
          console.warn('sessionCache is not available for this browser, using local variable instead');
          return this._data;
        }
      }
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      
    });
    global.cache.sessionOnly = global.cache.sessionCache = new SessionCache();
})(window.WebAccess);